import { Link } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
// Emergent auth returns to <origin>/dashboard#session_id=… which App.js hands to AuthCallback.
export const startGoogleSignIn = () => {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const GoogleSignInButton = ({ showTermsNote }) => (
  <>
    <button type="button" onClick={startGoogleSignIn} data-testid="google-signin" className="btn-outline text-sm w-full justify-center mb-4">
      <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.6 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 44c5.2 0 9.8-2 13.3-5.2l-6.2-5.2C29.1 34.7 26.7 36 24 36c-5.3 0-9.7-3.4-11.3-8.1l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.2-4.2 5.6l6.2 5.2C40.9 35 44 30 44 24c0-1.2-.1-2.4-.4-3.5z"/>
      </svg>
      Continue with Google
    </button>
    {showTermsNote && (
      <p className="font-mono text-[9px] tracking-[0.15em] uppercase text-[#A8A29E] -mt-2 mb-4" data-testid="google-terms-note">
        Continuing with Google means you agree to the <Link to="/terms" className="text-[#78716C] underline underline-offset-2">Terms</Link> and <Link to="/privacy" className="text-[#78716C] underline underline-offset-2">Privacy Policy</Link>.
      </p>
    )}
    <div className="flex items-center gap-3 my-6">
      <span className="flex-1 h-px bg-black/5" />
      <span className="font-mono text-[9px] tracking-[0.3em] uppercase text-[#A8A29E]">or with email</span>
      <span className="flex-1 h-px bg-black/5" />
    </div>
  </>
);
